module.exports = require("core-js/library/fn/symbol");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/symbol.js
// module id = 152
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460